<template>
  <b-form-group :label="label" :label-sr-only="noLabel">
    <template #label>
      <slot name="label"></slot>
    </template>
    <b-input-group v-bind:class="{ 'is-valid': state, 'is-invalid': state == false }">
      <slot name="prepend"></slot>
      <date-picker :readonly="readonly" dropright v-model="content" :config="options" v-mask="mask" autocomplete="off" :state="state" @input="handleInput" @dp-change="handleBlur"></date-picker>
      <slot name="append"></slot>
      <b-form-invalid-feedback :class="state == false ? 'd-block' : 'd-none'">{{ feedback }}</b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";
import helpers from "../../common/utils/helpers";

export default {
  name: "InputDateTime",
  props: {
    value: { type: String, default: "" },
    label: { type: String },
    noLabel: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    requiredMessage: { type: String },
    validate: { type: Boolean, default: null },
    type: { type: String },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      content: this.value,
      mask: "##/##/#### ##:##",
      validForm: false,
      hasError: false,
      errorMessage: "",
    };
  },
  computed: {
    
    requiredValid() {
      return !(this.required && (this.value == "" || this.value == null || this.value == "N/A" || this.value == 'Data inválida'));
    },
    state() {
      if (!this.validForm) return null;

      if (!this.requiredValid) return false;
      if (this.hasError) return false;
      if (this.validate != null) return this.validate;
      return true;
    },
    feedback() {
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t("CAMPOS_VALIDACAO.REQUERIDO").formatUnicorn({
            name: this.label,
          })
        );
      if (this.validate != null && !this.validate)
        return (
          this.invalidEmailMessage ||
          this.$t("CAMPOS_VALIDACAO.INVALIDO").formatUnicorn({
            name: this.label,
          })
        );
      if (this.hasError) return this.errorMessage;
      return "";
    },
    format() {
      if (this.type == "datetime") return "DD/MM/YYYY HH:mm";
      if (this.type == "time") return "HH:mm";
      return "DD/MM/YYYY";
    },
    formatEn() {
      if (this.type == "datetime") return "YYYY-MM-DD HH:mm";
      if (this.type == "time") return "HH:mm";
      return "YYYY-MM-DD";
    },
    options() {
      return {
        format: this.format,
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: "pt-Br",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          close: "far fa-times-circle",
          clear: "far fa-trash-alt",
        },
        widgetPositioning: {
          horizontal: "auto",
          vertical: "bottom",
        },
      };
    },
  },
  methods: {
    
    valid() {
      this.validForm = true;
      return this.state;
    },
    handleInput() {
      moment.locale("pt-br");
      this.$emit("input", moment(this.content, this.format).format(this.formatEn));
      this.hasError = false;
    },
    handleBlur(){
      this.$emit("blur");
    },
    clear() {
      moment.locale("pt-br");
      this.content = "";
      this.validForm = false;
      this.$emit("input", moment(this.content, this.format).format(this.formatEn));
    },
  },
  watch: {
    value: {
      handler(value) {
        if(helpers.formatarData(value, "YYYY") == '0001')
          return;
        
        if(value){
          if(value.indexOf('/') > -1){
            this.content = value;
          }else{
            this.content = moment(value, this.formatEn).format(this.format);
            if(this.content == 'Data inválida')
              this.content = null;
          }
        }else{
          this.content = null;
        }
      },
      immediate : true
    },
  },
  components: {
    datePicker,
  },
};
</script>
<style>
.is-valid input {
  border: 1px solid #0bb7af;
}
.is-invalid input {
  border: 1px solid #f64e60;
}
</style>
